import { useQuery } from "@tanstack/react-query"
import { getProductVariants } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetProductVariants() {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["product-variants"],
    queryFn: () => {
      if (!accessToken) throw new Error("Not authenticated")
      return getProductVariants(accessToken)
    },
    enabled: !!accessToken,
  })
}
